export const exterior_view01ImageOptions = {
  angle: 'exterior_view01',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SprayHood: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'BowSprit',
      dependency: 'HullColour'
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: null
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'SprayHood',
      dependency: null
    },
    {
      option: 'MastAndBoom',
      dependency: 'SprayHood'
    },
    {
      option: 'BoomCover',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP55/views/exterior_view01.js